<template>
  <div>
    <K-Loading :Loading="Loading" v-if="!datas"></K-Loading>
    <div v-else>
      <div class="seedTwoHead">种子标签二维码追溯系统</div>
	
      <section class="stBox">
        <div class="stTitle"><a><img src="/static/images/Normal19/icon_01.png"></a><a>种子信息</a></div>
        <div>
          <ul class="stMain">
            <li><a>品种名称：</a><a v-text="datas.product.name"></a></li>
            <li v-for="(item, index) in datas.product.attribute" :key="index">
              <a>{{ item.key }}：</a>
              <a>{{ item.value }}</a>
            </li>
            <li><a>生产经营者：</a><a v-text="datas.business.name"></a></li>
            <li><a>单元识别代码：</a><a v-text="code"></a></li>
            <li><a>追溯网址：</a><a style="text-decoration: underline;color:#83c326;" href="/#/SeedDetails" id="tagUrl">https://lj.oid.plus?{{ code }}</a></li>
          </ul>
        </div>
        <div class="stCopyright" style="padding-bottom:5px">技术支持：<a href="http://cnzcyj.com">链接科技有限公司</a></div>
        <!-- <div class="stCopyright" style="padding:0;"><a href="tel:"></a></div> -->

      </section>
    </div>
  </div>
</template>

<script>
let self;
import axios from 'axios'
import Swiper from 'swiper'
import Loading from '@/components/Loading.vue'
import Music from '@/components/Music.vue'
export default {
  name: 'Normal19',
  components: {
    'K-Loading': Loading,
    'K-Music': Music
  },
  data() {
    return {
      code: null,
      vcode: null,
      count: 2,
      msg: '',
      datas: null,
      hintTxt: null,
      Loading: {
        type: 1,
        txt: "数据请求中..."
      },
      Music: {
        url: null,
        type: false
      }
    }
  },
  created() {
    self = this;
    document.body.style.backgroundColor = "rgb(240, 248, 239)";

    //判断是演示还是真实码标
    if (this.$route.query.type == "demo") {
      self.GetDemoDatas(this.$route.query.pid, this.$route.query.rid);  //获取演示模板信息
    } else {
      self.code = self.GetCode();
      self.GetDatas();  //获取码标信息
    }
  },
  updated() {
    new Swiper('.banner', {
      autoplay: {
        delay: 5000
      },//可选选项，自动滑动
      loop: true, //可选选项，开启循环
      // pagination: {
      //   el: '.swiper-pagination',
      //   bulletActiveClass : 'Normal07-banner-active',
      // }
    })
  },
  methods: {
    GetDemoDatas(pid, rid) {
      axios.get(self.GetServerUrl(1) + "template_product/" + pid + "/" + rid)
        .then(function (response) {
          let datas = response.data.meta;
          let defaultDatas = JSON.parse(datas.default_basic.config_value);  //初始化默认信息

          if (datas.scan_count) {
            datas.scan_count = datas.scan_count;
          } else {
            datas.scan_count = 1;
          }
          datas.scan_first_time = "2017-10-31 12:12";
          datas.scan_first_address = "广东省深圳市";
          if (datas.focus) {
            datas.focus = JSON.parse(datas.focus);
          }
          if (datas.ref) {
            datas.ref = JSON.parse(datas.ref);
          } else {
            if (defaultDatas.ref) {
              datas.ref = JSON.parse(defaultDatas.ref);
            }
          }
          if (datas.menu) {
            datas.menu = JSON.parse(datas.menu);
          }
          if (datas.batch) {
            datas.batch = JSON.parse(datas.batch);
            datas.batch.qc = JSON.parse(datas.batch.qc);
          }
          if(datas.music && datas.music_is_show == 1){
            try {
              datas.music = JSON.parse(datas.music);
            } catch (error) {
              console.error(error)
            }
          }
          if (datas.video) {
            datas.video = JSON.parse(datas.video);
          }
          datas.activity_is_show = 1;

          //产品自定义属性
          if (datas.product.attribute) {
            datas.product.attribute = JSON.parse(datas.product.attribute);
          }

          //企业自定义属性
          if (datas.business.customize_data) {
            datas.business.customize_data = JSON.parse(datas.business.customize_data);
          }

          //默认信息
          if (!datas.process) {
            datas.process = defaultDatas.process;
          }
          if (!datas.process_demo) {
            datas.process_demo = defaultDatas.process_demo;
          }
          if (!datas.dealer) {
            datas.dealer = defaultDatas.dealer;
          }

          self.datas = datas;
          localStorage.setItem("wwm_seedDetail",JSON.stringify(datas));
          // document.title = self.datas.business.name;  //设置页面标题
        }).catch(function (error) {
          console.log(error)
          self.Loading.type = 3;
          self.Loading.txt = self.ErrorHint(error);
        })
    },
    GetDatas() {
      axios.get(self.GetServerUrl(1) + "query/" + self.code)
        .then(function (response) {
          let datas = response.data.meta.product_template;
          datas.scan_count = response.data.meta.scan_count;  //扫码次数
          datas.scan_first_time = response.data.meta.scan_first_time;  //扫码时间
          datas.scan_first_address = response.data.meta.scan_first_address;  //扫码地点
          datas.verify = response.data.meta.verify; //防伪码

          //激活自定义属性
          if (response.data.meta.activation_a) {
            datas.attribute = JSON.parse(response.data.meta.activation_a);
          }

          //发货自定义属性
          if (datas.dealer && datas.dealer.length) {
            datas.attribute = JSON.parse(datas.dealer[0].attribute);
          }

          //焦点图
          if (datas.focus) {
            datas.focus = JSON.parse(datas.focus);
          }
          //自定义栏目
          if (datas.ref) {
            datas.ref = JSON.parse(datas.ref);
          }
          //自定义菜单
          if (datas.menu) {
            datas.menu = JSON.parse(datas.menu);
          }
          //产品自定义属性
          if (datas.product.attribute) {
            datas.product.attribute = JSON.parse(datas.product.attribute);
          }
          //企业自定义属性
          if (datas.business.customize_data) {
            datas.business.customize_data = JSON.parse(datas.business.customize_data);
          }
          //批次信息
          if (datas.batch) {
            if (datas.batch.qc) {
              datas.batch.qc = JSON.parse(datas.batch.qc);
            }
          }
          if(datas.music && datas.music_is_show == 1){
            try {
              datas.music = JSON.parse(datas.music);
            } catch (error) {
              console.error(error)
            }
          }
          if (datas.video) {
            datas.video = JSON.parse(datas.video);
          }
          datas.activity_is_show = 1;
          self.datas = datas;

          localStorage.setItem("wwm_seedDetail",JSON.stringify(datas));
          // document.title = self.datas.business.name;  //设置页面标题
        }).catch(function (error) {
          console.log(error)
          self.Loading.type = 3;
          self.Loading.txt = self.ErrorHint(error);
        })
    },
    CodeVerify() {
      axios.get(self.GetServerUrl(1) + "queryVerify/" + self.code + "/" + self.vcode)
        .then(function (response) {
          var json = response.data;
          if (json.code == 200) {
            self.queryContent = response.data.meta;
            self.isShow = true;
            let msg;
            // if(self.queryContent.query_count > 1 && !self.datas.many_antifake_msg){
            //   msg = "您查询的码标已经被多次扫描，谨防假冒!";
            // }
            if(self.queryContent.query_count > 1 && self.datas.many_antifake_msg){
              msg = self.datas.many_antifake_msg;
            }
            if(self.queryContent.query_count <= 999 && !self.datas.first_antifake_msg){
              msg = `您所查询的是 ${self.datas.business.name} 正品，当前查询次数为 ${json.meta.query_count} 次，感谢查询 ！`;
            }
            if(self.queryContent.query_count <= 999 && self.datas.first_antifake_msg){
              msg = `${self.datas.first_antifake_msg}${self.datas.product.name}为正品，当前查询次数为${self.queryContent.query_count}次，感谢查询！首次查询时间${self.queryContent.query_first_time}`;
            }
            self.hintTxt = msg;

          } else {
            self.isShow = false;
          }

        }).catch(function (error) {
          console.log(error);
          self.hintTxt = "防伪码错误！";
          self.isShow = false;
          self.vcode = '';
        })
    },
    CloseTip() {
      self.hintTxt = null;
    },
    ViewMore(datas) {
      if (self.code) {
        this.$router.push({ path: "/ScanCodeRecord" }); // 模板路由跳转
      } else {
        alert("真实码标数据才能查看扫码记录！");
      }
    },
    inited(viewer) {
      self.$viewer = viewer
    },
    PreviewImgs() {
      self.$viewer.show();
      self.$viewer.update();
    },
    ClickMenu(data) {
      if (data.type != 2) {
        window.location.href = data.url;
      } else {
        this.$router.push({ path: "/qr?qr=" + data.qr });
      }
    }
  }
}
</script>

<style scoped>
.seedTwoHead{
    width: 100%;
    color: #fff;
    padding: 13px 0;
    font-size: 20px;
    text-align: center;
	background-color: #83c326;
}
.stBox{
	padding:0px 10px;
}
.stTitle{
	overflow: hidden;
	margin-top:20px;
}
.stTitle a{
	display: block;
	color:#83c326;
	float: left;
	font-size:17px;
	line-height:40px;
}
.stTitle img{
	display: block;
	width:35px;
	margin-right:5px;
}
.stMain{
	margin-top:5px;
	background-color: #e6f0e5;
	padding:0px 5px;
}
.stMain li{
	font-size:14px;
	padding:0px 5px;
	padding-bottom:10px;
	line-height:23px;
	overflow: hidden;
}
.stMain li a{
	display: block;
	float: left;
}
.stMain li:first-child{
	padding-top:10px;
}
.stMain li a:first-child{
	color:#444;
}
.stCopyright{
	font-size:12px;
	text-align: center;
	padding:20px 0;
}
.stCopyright a{
	color:#000;
	text-decoration: none;
}

.stMainTwo{
	margin-top:5px;
	background-color: #e6f0e5;
}
.stMainTwo li{
	overflow: hidden;
	color:#444;
	font-size:13px;
	border-bottom:1px solid #dceada;
}
.stMainTwo li:first-child{
	color:#000;
	font-size:14px;
}
.stMainTwo li:first-child a{
	padding:12px 0px;
}
.stMainTwo li a{
	float: left;
	width:49.5%;
	padding:10px 0px;
	display: block;
	text-align: center;
	border-right: 1px solid #dceada;
}
.stMainTwo li a:last-child{
	border-right: 0px;
}


</style>



// WEBPACK FOOTER //
// src/view/Normal19.vue